import { TopMenu } from '@layouts/Header/Header.types';
import React from 'react';
import { TopMenuLanguageSelector } from './components';
import { productShopUrl } from '@helpers/consts';

interface TopMenuProps {
  topMenu: TopMenu;
}

const TopMenu = ({ topMenu }: TopMenuProps) => {
  return (
    <div className='l-header-top-bar'>
      <div className='l-header-top-bar-ribbon'></div>
      <div className='l-header-container-specialmenu'>
        <div className='l-flex-items'></div>
        <div className='l-flex-items center'>
          <div className={`c-top-menu ${!topMenu ? 'loading' : ''}`}>
            <svg width='20' height='20' xmlns='http://www.w3.org/2000/svg' className='right-arc'>
              <path
                d='M 0 20
        A 20 20, 0, 0, 0, 20 0
        L 20 20 Z'
                fill='#F5F3F2'
              ></path>
            </svg>
            {topMenu &&
              topMenu.SectionLinks.map((item, index) => (
                <a
                  key={index}
                  className='c-top-menu-link'
                  href={item.Href}
                  title={item.Text}
                  target={item.Target}
                  //Story 365068 - Added new attribute i.e referrerpolicy="unsafe-url" if item.Href contains shop.alfalaval.com
                  {...(item.Href?.includes(productShopUrl) && { referrerPolicy: 'unsafe-url' })}
                >
                  {item.Text}
                </a>
              ))}
            {topMenu && topMenu.Languages && (
              <TopMenuLanguageSelector
                defaultLanguage={topMenu.DefaultLanguage}
                languages={topMenu.Languages}
              />
            )}
          </div>
        </div>
      </div>
      <div className='l-flex-items right'></div>
    </div>
  );
};

export default TopMenu;
